import React from "react";

const AtomSpinner: React.FC = () => (
  <div className="relative w-16 h-16">
    {/* nucleus */}
    <div className="absolute top-1/2 left-1/2 w-3 h-3 -mt-1.5 -ml-1.5 bg-[#00A3FF] rounded-full shadow-lg shadow-[#00A3FF]/50" />

    {/* orbit 1 */}
    <div className="absolute inset-0 animate-[spin_2s_linear_infinite]">
      <div className="absolute inset-0 border-2 border-[#00A3FF]/30 rounded-full">
        <div className="absolute -top-1 left-1/2 -ml-1 w-2 h-2 bg-[#00A3FF] rounded-full shadow-md shadow-[#00A3FF]/50" />
      </div>
    </div>

    {/* orbit 2 - rotated 60deg */}
    <div className="absolute inset-0" style={{ transform: "rotate(60deg)" }}>
      <div className="absolute inset-0 animate-[spin_2.5s_linear_infinite_reverse]">
        <div className="absolute inset-0 border-2 border-[#0077CC]/30 rounded-full">
          <div className="absolute -top-1 left-1/2 -ml-1 w-2 h-2 bg-[#0077CC] rounded-full shadow-md shadow-[#0077CC]/50" />
        </div>
      </div>
    </div>

    {/* orbit 3 - rotated -60deg */}
    <div className="absolute inset-0" style={{ transform: "rotate(-60deg)" }}>
      <div className="absolute inset-0 animate-[spin_3s_linear_infinite]">
        <div className="absolute inset-0 border-2 border-[#00A3FF]/20 rounded-full">
          <div className="absolute -top-1 left-1/2 -ml-1 w-2 h-2 bg-[#00A3FF]/80 rounded-full shadow-md shadow-[#00A3FF]/30" />
        </div>
      </div>
    </div>
  </div>
);

interface LoadingPageProps {
  message?: string;
  variant?: "dark" | "light";
  fullScreen?: boolean;
}

const LoadingPage: React.FC<LoadingPageProps> = ({
  message = "Loading...",
  variant = "dark",
  fullScreen = true,
}) => {
  const bgClass = variant === "dark" ? "bg-dark-bg" : "bg-transparent";
  const textClass = variant === "dark" ? "text-white/60" : "text-gray-600";
  const sizeClass = fullScreen ? "min-h-screen" : "flex-1 py-20";

  return (
    <div className={`${sizeClass} ${bgClass} flex flex-col items-center justify-center`}>
      <AtomSpinner />
      <p className={`mt-6 ${textClass} text-sm tracking-wide`}>{message}</p>
    </div>
  );
};

export default LoadingPage;
